import { Controller, useFormContext } from 'react-hook-form';
import useTranslation from 'next-translate/useTranslation';

//libs
import { enable_weekly_digest_email } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

//components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

export function PlatformWeeklyDigest() {
    const { t } = useTranslation('settings');

    const options = enable_weekly_digest_email(t);

    const {
        control,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <Controller
            key={'enable_weekly_digest_email'}
            control={control}
            name={'enable_weekly_digest_email'}
            render={({ field: { onChange, value } }) => {
                return (
                    <SelectComponent
                        selected={options?.find((item) => value['value'] === item.value)}
                        setSelected={onChange}
                        label={t('platform_page.enable_weekly_digest')}
                        error={errors.enable_notifications?.message}
                        options={options}
                    />
                );
            }}
        />
    );
}
